import { render } from "./Contact.vue?vue&type=template&id=35fa0a35&scoped=true&bindings={}"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=35fa0a35&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35fa0a35"

export default script